export default () => ({
  recalculateTotals() {
    const form = this.$el.closest('form')
    form.querySelector('input[name="recalculate"]').value = '1'
    form.requestSubmit()
  },
})
